module.exports = __webpack_public_path__ + "img/12_mathias-p-r-reding.366f31d0.jpg";